import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';


import { CompareProductsComponent } from '../compare-products/compare-products.component';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatCardModule,
    MatTooltipModule
  ],
  exports: [
    CompareProductsComponent
  ],
  providers: [
  ],
  declarations: [
    CompareProductsComponent
  ]
})
export class CompareProductsModule { }
